import { types } from 'mobx-state-tree';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';

export interface CashflowSingleChartProps {
  id: number;
  label: string;
  price: CurrencyProps;
  values: number[];
}

export const CashflowSingleChart = types.model({
  id: types.number,
  label: types.string,
  price: Currency,
  values: types.optional(types.array(types.number), []),
});
